import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import makeClassName from 'shared-utils/src/makeClassName';
import createStyle from 'shared-utils/src/createStyle';

import style, { mainCls } from './style';
import TagButton from '../TagButton';

const useStyles = createStyle(style);

/**
 * Function to render the tags container
 * @param {Array} props.list - list of tags to render
 * @param {Function} props.actionToPerform - function to perform when a tag is clicked
 * @param {String} props.notShownOn - 'desktop' or 'mobile' or 'none'
 * @returns {JSX.Element}
 */
const TagsContainer = ({
  list,
  actionToPerform,
  notShownOn,
  style,
}) => {
  const cls = useStyles();
  const tagRef = useRef(null);
  const clsNotShowOn =
    notShownOn === 'none' ? '' : `__not-show-on-${notShownOn}`;
  const mainClsCnt = makeClassName([
    cls[mainCls],
    cls[`${mainCls}${clsNotShowOn}`],
  ]);
  return (
    <div className={mainClsCnt} style={style}>
      {list.map((filter, index) => {
        const n = index;
        const action = () => actionToPerform(filter.name);
        return (
          <TagButton
            ref={tagRef}
            index={n}
            action={action}
            label={filter.displayValue}
          />
        );
      })}
    </div>
  );
};

TagsContainer.propTypes = {
  list: PropTypes.array,
  actionToPerform: PropTypes.func,
  notShownOn: PropTypes.string,
  style: PropTypes.object,
};

TagsContainer.defaultProps = {
  list: [],
  actionToPerform: () => {},
  notShownOn: 'none',
  style: {},
};
export default TagsContainer;
